module.exports = __webpack_public_path__ + "img/检索结果.b4b61eb5.png";